// export default 'http://cgzf.zuul.resolr.com/'
// export default 'http://ydyenr.zuul.resolr.com/'
// export default '' // 测试

// export default 'http://10.191.54.156:8080/'
// http://sara.zuul.resolr.com
// http://114.115.240.34:8080/
export default {
  // baseUrl: 'http://payServer.zuul.resolr.com/',
  baseUrl: "https://zydz-menhu.ouchn.edu.cn/zhs-manage-service/", // 正式
  baseOtherUrl: "https://zydz-menhu.ouchn.edu.cn/oauth/", // 正式
  baseOtherTwoUrl: "https://zydz-menhu.ouchn.edu.cn/zhs-manage/",
 /*   baseUrl: 'http://114.116.201.37/zhs-manage-service/', // 测试
  baseOtherUrl: 'http://114.116.201.37/manage-server/', // 测试
  baseOtherTwoUrl: 'http://114.116.201.37/zhs-manage/' // 测试  */
 /*  baseUrl: 'http://192.168.2.87:8089', // 魏
  baseOtherUrl: 'http://192.168.2.87:8080', // 
  baseOtherTwoUrl: 'http://192.168.2.87:8080' //  */
};
